import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const DistractofColumbia = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>District of Columbia Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Property Disclosure Statement: Required for residential sales.
        </Text>

        <Text style={styles.listItem}>
          2. Lead-Based Paint: Mandatory disclosure for homes built before 1978.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          4.{' '}
          <Text style={styles.underline}>
            Seller's Property Disclosure Statement
          </Text>{' '}
          – Required by law for sellers to complete and provide to buyers. This
          form is approved by the District of Columbia.
        </Text>
      </View>
    </View>
  );
};

export default DistractofColumbia;
